import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCurrentAccountFilterTemplatesThunk } from "./getCurrentAccountFilterTemplatesThunk";
import {
  AccountResourceFilter2,
  cloudChiprApi,
  ProviderType,
} from "../../../../services/cloudchipr.api";
import { RootState } from "../../../store";

type Args = {
  filterTemplateId: string;
  provider: ProviderType;
  name?: string;
  accountIds?: string[];
  filters?: AccountResourceFilter2[];
};

export const patchFilterTemplateThunk = createAsyncThunk(
  "filter/patchFilterTemplateThunk",
  async (
    { filterTemplateId, name, accountIds, filters, provider }: Args,
    { dispatch, getState },
  ) => {
    const state = getState() as RootState;
    const { account } = state;

    const { patchUsersMeOrganisationsCurrentFilterSetsByFilterSetIdV2 } =
      cloudChiprApi.endpoints;

    if (!account.id) {
      return;
    }

    try {
      await dispatch(
        patchUsersMeOrganisationsCurrentFilterSetsByFilterSetIdV2.initiate({
          filterSetId: filterTemplateId,
          body: {
            name,
            filters,
            cloud_provider: provider,
            account_ids: accountIds,
          },
        }),
      ).unwrap();

      await dispatch(getCurrentAccountFilterTemplatesThunk());
    } catch (error) {
      return error;
    }
  },
);
